import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import { getData, postData, deleteData } from "../../api";

import { Website_Type } from "../../common";

export const loginCartLuxury = async () => {
  let cartItems = [];
  const existingCart = Cookies.get("coinz_kart_luxury_cart");
  if (existingCart) {
    cartItems = JSON.parse(existingCart);
  }
  if (cartItems.length > 0) {
    await Promise.all(
      cartItems.map(async (value) => {
         await postData(`/luxury/cart/add`, {
          product_id: value?.product_id,
          variant_id: value?.variant_id,
          quantity_id: value?.quantity_id,
          quantity: value?.quantity,
        });
      }),
    );
  }
  await Cookies.remove("coinz_kart_luxury_cart");
};


export const AddToCartLuxury = async (d) => {
  try {
    // ✅ If user logged in → API cart
    if (Cookies.get("coinz_kart_security")) {
      await postData(`/luxury/cart/add`, {
        product_id: d.product_id,
        variant_id: d.variant_id,
        quantity_id: d.quantity_id,
        quantity: d.quantity || 1,
      });

      return true;
    }

    // ✅ Local cookie cart
    let cartItems = [];

    const existingCart = Cookies.get("coinz_kart_luxury_cart");

    if (existingCart) {
      cartItems = JSON.parse(existingCart);
    }

    // ✅ check if same item exists
    const existingIndex = cartItems.findIndex(
      (item) =>
        item.product_id === d.product_id &&
        item.variant_id === d.variant_id &&
        item.quantity_id === d.quantity_id,
    );

    if (existingIndex !== -1) {
      // ✅ item exists → increase quantity
      cartItems[existingIndex].quantity =
        (cartItems[existingIndex].quantity || 1) + 1;
    } else {
      // ✅ new item → push
      cartItems.push({
        id: uuidv4(),
        product_id: d.product_id,
        variant_id: d.variant_id,
        quantity_id: d.quantity_id,
        quantity: 1,
      });
    }

    // ✅ save back to cookie
    Cookies.set("coinz_kart_luxury_cart", JSON.stringify(cartItems), {
      expires: 7, // optional (7 days)
    });

    return true;
  } catch (error) {
    console.log(error);
  }
};

export const CartQuantity = async (id, type, size_id) => {
  try {
    if (Cookies.get("coinz_kart_security")) {
       await postData(`/luxury/cart/quantity`, {
        cart_id: id,
        type: type,
      });
      return true;
    } else {
      console.log(id, "id id without login");

      let cartItems = [];

      const existingCart = Cookies.get("coinz_kart_luxury_cart");
      if (existingCart) {
        cartItems = JSON.parse(existingCart);
      }
      const existingItemIndex = cartItems.findIndex((item) => item.id === id);

      console.log(existingItemIndex, "existingItemIndex existingItemIndex");

      if (existingItemIndex === -1) {
      } else {
        if (
          Number(cartItems[existingItemIndex]?.quantity) === 1 &&
          type === "minus"
        ) {
          // cartItems.splice(existingItemIndex, 1);
        } else {
          if (type === "minus") {
            cartItems[existingItemIndex].quantity -= 1;
          } else {
            cartItems[existingItemIndex].quantity =
              Number(cartItems[existingItemIndex].quantity) + 1;
          }
        }
        Cookies.set("coinz_kart_luxury_cart", JSON.stringify(cartItems));
      }
    }
    return true;
  } catch (error) {
    console.log(error);
  }
};

export const getCartLuxury = async (signin) => {
  try {
    if (Cookies.get("coinz_kart_security")) {
      return await getData(`/luxury/cart/show`);
    } else {
      const cartFromCookies = Cookies.get("coinz_kart_luxury_cart");

      console.log(
        cartFromCookies,
        "cartFromCookies cartFromCookies cartFromCookies",
      );

      let cartData;
      if (typeof cartFromCookies === "string") {
        cartData = JSON.parse(cartFromCookies);
      }

      return await postData(`/luxury/cart/withoutlogin/show`, cartData);
    }
  } catch (error) {
    console.log(error);
  }
};

export const getOrder = async (id) => {
  try {
    return await getData(`/order-process/Allorderget/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getAppsetup = async () => {
  try {
    return await getData(`/without-login/all-app-setup`);
  } catch (error) {
    console.log(error);
  }
};

export const getGiftWrapPriceLuxuxry = async () => {
  try {
    return await getData(
      `/without-login/all-gift-wrap-price?website_type_id=${Website_Type?.Luxury}`,
    );
  } catch (error) {
    console.log(error);
  }
};

export const getAllPricesLuxury = async (giftData,rewardStatus) => {
  try {
    return await postData(`/luxury/order-process/order-calculation`, {
      giftdata: giftData,
      reward_status:rewardStatus
    });
  } catch (error) {
    console.log(error);
  }
};

export const deleteCartLuxury = async (id) => {
  try {
    if (Cookies.get("coinz_kart_security")) {
      return await deleteData(`/luxury/cart/${id}`);
    } else {
      const existingCart = Cookies.get("coinz_kart_luxury_cart");

      if (existingCart) {
        let cartItems = JSON.parse(existingCart);
        const updatedCartItems = cartItems.filter((item) => item.id !== id);

        // save updated cart
        Cookies.set(
          "coinz_kart_luxury_cart",
          JSON.stringify(updatedCartItems),
          {
            expires: 7,
          },
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const getCartCheck = async (data) => {
  try {
    if (Cookies.get("coinz_kart_security")) {
      const queryParams = new URLSearchParams(data).toString();
      return await getData(`/cart/getCart?${queryParams}`);
    } else {
      let cartItems = [];
      const existingCart = Cookies.get("coinz_kart_cart");
      if (existingCart) {
        cartItems = JSON.parse(existingCart);
      }
      const existingItemIndex = cartItems.findIndex(
        (item) =>
          item.product_id === data?.product_id &&
          item.variant_id === data?.variant_id,
      );
      if (existingItemIndex === -1) {
        return { success: false, cartItem: cartItems[existingItemIndex] };
      } else {
        return { success: true, cartItem: cartItems[existingItemIndex] };
      }
    }
  } catch (error) {
    console.log(error);
  }
};
